export function renderHeader(container, { activeNote, isDarkMode, user, isConnected, onTogglePin, onDeleteNote, onOpenReminder, onOpenReview, onToggleDarkMode, onOpenAccount }) {
  const isPinned = activeNote?.isPinned || false;
  const hasReminder = !!activeNote?.reminderAt;
  const isDraft = !activeNote || activeNote.id === 'composer';
  
  container.innerHTML = `
    <header class="app-header">
      <div class="header-brand">
        <span class="brand-title">FlowNote</span>
      </div>

      <div class="header-actions">
        <button class="icon-btn" id="btn-account" title="${user ? `Signed in as ${user.email || user.displayName || 'account'}${isConnected ? ' (synced)' : ''}` : 'Sign in to sync'}">
          ${user ? '👤' : '🔐'}
        </button>

        <button class="icon-btn" id="btn-review" title="Recall Flashcards">
          🧠
        </button>

        <button class="icon-btn" id="btn-theme-toggle" title="Toggle Dark Mode">
          ${isDarkMode ? '☀️' : '🌙'}
        </button>

        ${!isDraft ? `
          <button class="icon-btn ${hasReminder ? 'active' : ''}" id="btn-reminder" title="Set Reminder">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          </button>
          <button class="icon-btn ${isPinned ? 'active' : ''}" id="btn-pin" title="Pin Note">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="17" x2="12" y2="22"></line><path d="M5 17h14l-1.5-6.5L19 4H5l1.5 6.5L5 17z"></path></svg>
          </button>
          <button class="icon-btn" id="btn-delete" title="Delete Note">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
          </button>
        ` : ''}
      </div>
    </header>
  `;

  // Bind every match rather than the first. There is normally exactly one, but
  // any tooling that mounts a duplicate copy of this markup (design preview,
  // snapshot harness) would otherwise leave the visible header's buttons dead.
  const bind = (id, handler) => {
    container.querySelectorAll('#' + id).forEach((el) => { el.onclick = handler; });
  };

  bind('btn-account', onOpenAccount);
  bind('btn-review', onOpenReview);
  bind('btn-theme-toggle', onToggleDarkMode);
  bind('btn-reminder', onOpenReminder);
  bind('btn-pin', onTogglePin);
  bind('btn-delete', onDeleteNote);
}
